const NumeroSinFormato = (numValor) => {
  return numValor.replace(".", "");
};

// 1000.36 a 1000,36
const ConvertirNumeroParaFormatear = (numValor) => {
  return numValor.toString().replace(".", ",");
};

//Convierte el numero formateado a numero para sumar 1.000,35 a 1000.35
const ConvertirNumero = (numValor) => {
  let Numero = 0;
  if (typeof numValor === "number") {
    Numero = parseFloat(numValor);
  } else if (typeof numValor === "string") {
    var SinFormato = numValor.replace(".", "");
    numValor = SinFormato.replace(",", ".");
    Numero = parseFloat(numValor);
  }
  return Numero;
};

const NumeroFormateado = (numValor, bConSigno, bConDecimal, NumDecimal) => {
  let numberFormat;
  if (bConSigno) {
    if (bConDecimal) {
      numberFormat = new Intl.NumberFormat("es-CL", {
        minimumFractionDigits: NumDecimal === 0 ? 0 : 1, // Mínimo de 2 decimales
        maximumFractionDigits: NumDecimal, // Máximo de 4 decimales (ajusta esto según tus necesidades)
        currency: "CLP",
      });
    } else {
      numberFormat = new Intl.NumberFormat("es-CL", {
        minimumFractionDigits: 0, // Sin Decimal
        maximumFractionDigits: 0, // Sin Decimal
        currency: "CLP",
      });
    }
  } else {
    if (bConDecimal) {
      // Redondear a 3 decimales
      if (numValor % 1 !== 0) {
        numberFormat = new Intl.NumberFormat("es-CL", {
          minimumFractionDigits: NumDecimal, // Mínimo de 2 decimales
          maximumFractionDigits: NumDecimal, // Máximo de 4 decimales (ajusta esto según tus necesidades)
        });
      } else {
        numberFormat = new Intl.NumberFormat("es-CL", {
          minimumFractionDigits: 0, // Sin Decimal
          maximumFractionDigits: 0, // Sin Decimal
        });
      }
    } else {
      numberFormat = new Intl.NumberFormat("es-CL", {
        minimumFractionDigits: 0, // Sin Decimal
        maximumFractionDigits: 0, // Sin Decimal
      });
    }
  }
  let numValoraFormatear = 0;
  if (numValor % 1 !== 0) {
    if (typeof numValor !== "number") {
      numValor = numValor.replace(",", ".");
      numValor = parseFloat(numValor);
    }
    numValoraFormatear = numValor.toFixed(bConDecimal ? NumDecimal : 0);
  } else {
    numValoraFormatear = numValor;
  }
  const formattedNumber = numberFormat.format(numValoraFormatear);
  return formattedNumber;
};

const numerico = {
  NumeroFormateado,
  NumeroSinFormato,
  ConvertirNumero,
  ConvertirNumeroParaFormatear,
};

export default numerico;
